export enum ColumnTypes {
    SingleLineText = "Single Line Text",
    MultiLineText = "Multi Line Text",
    SingleSelection = "Single Selection",
    MultipleSelection = "Multiple Selection",
    Attachments = "Attachments",
    Checkbox = "Checkbox",
    RichText = "Rich Text"
};